import { ActionType } from '../infrastructure/actionTypes';
import { IFillerImage } from '../infrastructure/interfaces';

export default (list: IFillerImage[] = [], action: any) => {
    switch (action.type) {
        case ActionType.GET_FILLER_IMAGE_DONE:
            const { fillerImages } = action;
            return fillerImages;

        case ActionType.EDIT_FILLER_IMAGE_DONE:
            const { updatedFillerImage } = action;
            const updatedList = list.map((f) => {
                return (f.id == updatedFillerImage.id) ? updatedFillerImage : f
            });
            return updatedList

        case ActionType.DELETE_FILLER_IMAGE_DONE:
            const filteredImages = list.filter(image => image.id !== action.fillerImageId);
            return filteredImages;

        case ActionType.CREATE_FILLER_IMAGE_DONE:
            const { newFillerImage } = action;
            return list.concat(newFillerImage);

        default:
            return list;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/fillerImageList.ts